import { DataType } from '@shared/extension/enums/data-type.enum';
import { Observable } from 'rxjs';
import { LocalStorageItem } from '../../interfaces';

export abstract class AbstractLocalStorageService {
  abstract getLocalStorage<T = string>(key: string, valueType?: DataType): Promise<T>;
  abstract setLocalStorage(key: string, value: unknown): Promise<void>;
  abstract handleLocalStorageChanges(): Observable<LocalStorageItem>;

  getDataString(data: unknown): string {
    return typeof data === 'object' || data === null
      ? JSON.stringify(data)
      : typeof data !== 'string'
        ? data.toString()
        : data;
  }

  getDataFromType(data: string | undefined, type: DataType): unknown {
    if (data === undefined) {
      return data;
    }
    if (data === 'null') {
      return null;
    }
    let value: unknown = data;
    if (type === DataType.Boolean) {
      value = data === 'true';
    } else if (type === DataType.Number) {
      value = Number(data);
    } else if (type === DataType.Object) {
      value = data ? JSON.parse(data) : null;
    }
    return value;
  }
}
